require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// /~/babel-runtime/~/core-js/library/fn/object/get-prototype-of.js
// module id = 1098
// module chunks = 0